import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NotifyPaymentModal from './NotifyPaymentModal';

function CopyButton({ text, t }) {
    const [copied, setCopied] = useState(false);

    const copy = () => {
        if (!text || !navigator.clipboard) return;
        navigator.clipboard.writeText(String(text))
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
            })
            .catch(() => {});
    };

    return (
        <button
            type="button"
            onClick={copy}
            style={{
                border: '1px solid #B6B6B7',
                background: '#fff',
                color: '#4A4A4A',
                borderRadius: '0.25rem',
                fontSize: '0.68rem',
                padding: '0.1em 0.5em',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
            }}
        >
            {copied ? t('bank_transfer.copied') : t('bank_transfer.copy')}
        </button>
    );
}

function DataLine({ label, value, copyable, t }) {
    if (value === undefined || value === null || value === '') return null;
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem',
            padding: '0.4rem 0',
            borderBottom: '1px dashed #eee',
            fontSize: '0.9rem',
        }}>
            <span style={{ color: '#4A4A4A' }}>{label}</span>
            <span style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.5rem', textAlign: 'right' }}>
                {value}
                {copyable && <CopyButton text={value} t={t} />}
            </span>
        </div>
    );
}

export default function BankTransferInstructions({ data, onDone }) {
    const { t } = useTranslation();
    if (!data) return null;

    const {
        currency,
        amount_formatted,
        currency_symbol,
        reference,
        liquidation_id,
        liquidation_month,
        data_html,
        notify_email,
    } = data;

    const totalDisplay = `${currency_symbol || currency || ''} ${amount_formatted || ''}`.trim();
    const email = notify_email || 'pagos@dashbo.io';

    return (
        <div className="box" style={{ marginBottom: '1.5rem' }}>
            <header className="box-header">
                <h2 className="box-title">{t('bank_transfer.title')}</h2>
            </header>

            <div style={{ padding: '1rem 1.5rem' }}>
                <p style={{ color: '#4A4A4A', fontSize: '0.92rem', marginBottom: '1.1rem' }}>
                    {t('bank_transfer.lead')}
                </p>

                <div style={{ background: '#fff', border: '1px solid #e3e6ea', borderRadius: '0.4rem', padding: '0.4rem 1rem' }}>
                    <DataLine label={t('bank_transfer.total_label')} value={totalDisplay} copyable t={t} />
                    <DataLine label={t('bank_transfer.reference')} value={reference} copyable t={t} />
                </div>

                {data_html && (
                    <div style={{ marginTop: '0.9rem' }}>
                        <div style={{ fontSize: '0.82rem', fontWeight: 700, color: '#4A4A4A', marginBottom: '0.4rem' }}>
                            {t('bank_transfer.account_details')}
                        </div>
                        <div
                            style={{
                                background: '#fff',
                                border: '1px solid #e3e6ea',
                                borderRadius: '0.4rem',
                                padding: '0.75rem 1rem',
                                fontSize: '0.9rem',
                                lineHeight: 1.8,
                            }}
                            dangerouslySetInnerHTML={{ __html: data_html }}
                        />
                    </div>
                )}

                <ol style={{ margin: '1rem 0 0', paddingLeft: '1.2rem', fontSize: '0.88rem', color: '#4A4A4A' }}>
                    <li style={{ marginBottom: '0.25rem' }}>{t('bank_transfer.step_1')}</li>
                    <li style={{ marginBottom: '0.25rem' }}>{t('bank_transfer.step_2', { email })}</li>
                    <li>{t('bank_transfer.step_3')}</li>
                </ol>

                <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginTop: '1.1rem', flexWrap: 'wrap' }}>
                    <NotifyPaymentModal
                        liquidationId={liquidation_id}
                        liquidationMonth={liquidation_month}
                    />
                    <button className="btn -alt -negative" onClick={onDone} style={{ fontSize: '0.85em' }}>
                        {t('bank_transfer.done_later')}
                    </button>
                </div>
            </div>
        </div>
    );
}
